"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var PropTypes = require("prop-types");
var React = require("react");
var react_sortable_hoc_1 = require("react-sortable-hoc");
var thumb_1 = require("./thumb");
var ThumbList = /** @class */ (function (_super) {
    tslib_1.__extends(ThumbList, _super);
    function ThumbList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ThumbList.prototype.renderThumbs = function () {
        var _this = this;
        return this.props.photos.map(function (photo, i) { return (React.createElement(thumb_1.default, { key: i, index: i, photo: photo, onEdit: function () { return _this.props.onEditPhoto(photo); }, onRemove: function () { return _this.props.onRemovePhoto(photo); }, allowEdit: _this.props.allowEdit })); });
    };
    ThumbList.prototype.render = function () {
        return (React.createElement("div", { className: "img-uploader__thumbs" },
            this.renderThumbs(),
            this.props.children));
    };
    return ThumbList;
}(React.Component));
ThumbList.propTypes = {
    children: PropTypes.node,
    photos: PropTypes.array.isRequired,
    onEditPhoto: PropTypes.func.isRequired,
    onRemovePhoto: PropTypes.func.isRequired,
    allowEdit: PropTypes.bool.isRequired,
};
exports.default = react_sortable_hoc_1.SortableContainer(ThumbList); // eslint-disable-line new-cap
//# sourceMappingURL=thumb_list.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/photos/thumb_list.js
// module id = yUat
// module chunks = 20 21